import "./styles.css";

import Typography from "@mui/material/Typography";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/pro-regular-svg-icons";
import { faNewspaper, faUserGroup } from "@fortawesome/pro-duotone-svg-icons";
import { useLocation, useNavigate } from "react-router-dom";

import { ConteudoCardProps } from "../../../interfaces/props/SaudeBemEstar/Conteudos/ConteudoCardProps";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import { Box, Divider } from "@mui/material";
import { sxDivider } from "../../../assets/styles/CommonSxProps";

function ConteudoCard({ conteudo, indice, contentListLenght }: ConteudoCardProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const accessibility = useAccessibility();
  const cardConstrastStyle = { ...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility };
  const currentPath = location.pathname;

  const handleSeeContent = (e: React.MouseEvent<HTMLDivElement> | React.KeyboardEvent<HTMLDivElement>) => {
    let event = e.nativeEvent;
    event.stopPropagation();
    if ((event instanceof KeyboardEvent && (event.key === "Enter" || event.key === " ")) || (event instanceof MouseEvent)) {
      const newPath = `${currentPath}/${conteudo.idMatEducativo}`;
      navigate(newPath);
    }
  };

  return (
    <>
      <div style={cardConstrastStyle} className="conteudo-card">
        <Box className="conteudo-card-info" onClick={handleSeeContent}>
          <div style={{ color: accessibility.contrastMode ? accessibility.contrastColor : "" }} className="conteudo-card-icon-holder">
            <FontAwesomeIcon style={accessibility.textStyleAccessibility} icon={faNewspaper} className="fa-icon32x32" />
          </div>
          <div className="conteudo-card-info-holder">
            <div className="conteudo-card-content">
              <Typography style={accessibility.calculateTextStyle(12)} className="conteudo-card-date">
                {conteudo.data}
              </Typography>
              <Typography style={accessibility.textStyleAccessibility} className="conteudo-card-title">
                <b>{conteudo.titulo}</b>
              </Typography>
              <div style={accessibility.textStyleAccessibility} className="conteudo-card-description" dangerouslySetInnerHTML={{ __html: conteudo.conteudo }} />
            </div>
            <button style={accessibility.textStyleAccessibility} className="conteudo-card-link" aria-label={`Ver conteúdo sobre ${conteudo.titulo}`}>
              Ver conteúdo
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
          </div>
        </Box>
      </div>
      {indice < contentListLenght - 1 && <Divider sx={sxDivider} />}
    </>
  );
}

export default ConteudoCard;
